export var CustomRulesSection;
(function (CustomRulesSection) {
    CustomRulesSection["Timing"] = "timing";
    CustomRulesSection["Oraculo"] = "oraculo";
    CustomRulesSection["VisitorProfile"] = "visitorProfile";
    CustomRulesSection["VisitorBehaviour"] = "visitorBehaviour";
    CustomRulesSection["Search"] = "search";
    CustomRulesSection["TravelParty"] = "travelParty";
    CustomRulesSection["DataVariables"] = "dataVariables";
    CustomRulesSection["Demand"] = "demand";
    CustomRulesSection["Integrations"] = "integrations";
})(CustomRulesSection || (CustomRulesSection = {}));
export var ConditionKind;
(function (ConditionKind) {
    ConditionKind["Exclude"] = "exclude";
    ConditionKind["Include"] = "include";
})(ConditionKind || (ConditionKind = {}));
export var Operator;
(function (Operator) {
    Operator["Any"] = "any";
    Operator["Is"] = "is";
    Operator["Are"] = "are";
    Operator["IsBetween"] = "isBetween";
    Operator["AreBetween"] = "areBetween";
    Operator["IsLower"] = "isLower";
    Operator["AreLower"] = "areLower";
    Operator["IsHigher"] = "isHigher";
    Operator["IsGreater"] = "isGreater";
    Operator["AreGreater"] = "areGreater";
    Operator["IsBefore"] = "isBefore";
    Operator["AreBefore"] = "areBefore";
    Operator["IsAfter"] = "isAfter";
    Operator["AreAfter"] = "areAfter";
    Operator["Contain"] = "contain";
})(Operator || (Operator = {}));
export var DataVariableRuleOperator;
(function (DataVariableRuleOperator) {
    DataVariableRuleOperator["Is"] = "is";
    DataVariableRuleOperator["IsNot"] = "isNot";
    DataVariableRuleOperator["AnyValue"] = "anyValue";
    DataVariableRuleOperator["NotAnyValue"] = "notAnyValue";
    DataVariableRuleOperator["Lower"] = "lower";
    DataVariableRuleOperator["Greater"] = "greater";
    DataVariableRuleOperator["Contains"] = "contains";
    DataVariableRuleOperator["NotContains"] = "notContains";
})(DataVariableRuleOperator || (DataVariableRuleOperator = {}));
/**
 * The visitor registration status in the website own credentials system.
 */
export var VisitorStatus;
(function (VisitorStatus) {
    /**
     * @alias VisitorStatus.RegisteredAndLogged
     * @deprecated
     */
    VisitorStatus["Registered"] = "registered";
    /**
     * @alias VisitorStatus.NotLogged
     * @deprecated
     */
    VisitorStatus["NonRegistered"] = "non_registered";
    /**
     * The visitor is currently logged-in. Implicitly the visitor needs to be registered,
     * however there should be no strict check about registration status on implementations.
     */
    VisitorStatus["RegisteredAndLogged"] = "registered";
    /**
     * The visitor is not registered. This implicitly means the visitor is also
     * NOT currently logged-in, as being logged-in would imply registration.
     */
    VisitorStatus["NotRegisteredAndNotLogged"] = "non_registered_nor_logged";
    /**
     * The visitor is registered. If the visitor were to be currently logged-in that (too)
     * would imply It is registered.
     */
    VisitorStatus["RegisteredOrLogged"] = "registered_all";
    /**
     * The visitor is registered AND is not currently logged-in.
     */
    VisitorStatus["RegisteredAndNotLogged"] = "registered_non_logged";
    /**
     * The visitor is currently not logged-in, disregarding registration status.
     */
    VisitorStatus["NotLogged"] = "non_registered";
})(VisitorStatus || (VisitorStatus = {}));
// This is for the thn/instant login system
export var VisitorLogin;
(function (VisitorLogin) {
    VisitorLogin["Logged"] = "logged";
    VisitorLogin["NonLogged"] = "nonLogged";
})(VisitorLogin || (VisitorLogin = {}));
export var VisitorBehaviourInteractionType;
(function (VisitorBehaviourInteractionType) {
    VisitorBehaviourInteractionType["Any"] = "any";
    VisitorBehaviourInteractionType["First"] = "first";
    VisitorBehaviourInteractionType["All"] = "all";
    VisitorBehaviourInteractionType["Search"] = "search";
    VisitorBehaviourInteractionType["Booked"] = "booked";
    VisitorBehaviourInteractionType["Custom"] = "custom";
})(VisitorBehaviourInteractionType || (VisitorBehaviourInteractionType = {}));
//# sourceMappingURL=rule.types.js.map